module.exports = __webpack_public_path__ + "img/account-icon.d4f89c9f.svg";